module.exports = __webpack_public_path__ + "assets/img/left-bottom.2825713d.png";